export default __webpack_public_path__ + "static/apace_merchants_thumb-07affa5e8b9c34855e6c9c4fa7878127.jpg";